import global from './Globals';

export default {
  formHeaderText: global.white,
  formGroupText: global.primary,
  formGroupTextError: global.error,
  formGroupInput: global.white,
  formGroupInputActive: global.secondary,
  formGroupBorder: global.grey700,
  formGroupBorderError: global.error,
  formGroupBg: 'rgba(255, 255, 255, 0.15)',
  formGroupBgDisabled: global.grey900,
  formGroupFocusBorder: global.secondary,
  formGroupFocusGlow: 'rgba(43, 170, 227, 0.4)',

  eyeColour: 'rgba(255, 255, 255, 0.5)',
  eyeColourHover: 'white',
};
